import styled from "styled-components";
import { themeGet } from "styled-system";

import theme from "pstat-anywhere/themes/policystat/theme";

export const FloatContainer = styled.div`
  position: absolute;
  top: ${themeGet("space.5")}px;
  bottom: 0;
  left: 0;
  z-index: ${theme.layers.secondaryNav - 1};
  pointer-events: none;
`;

export default FloatContainer;
